import { Field } from "formik";

import IsNonResidentSelection from "components/lib/Shared/IsNonResidentSelection";
import ResidentialAddressDetailsFormKeCiFoRe from "../../AddressParticularsComponents/ResidentialAddressComponents/ResidentialAddressDetailsFormKeCiFoRe";
import ResidentialAddressDetailsFormFoMi from "../../AddressParticularsComponents/ResidentialAddressComponents/ResidentialAddressDetailsFormFoMi";
import ResidentialPhysicalAddressLoCo from "../../AddressParticularsComponents/ResidentialAddressComponents/ResidentialPhysicalAddressLoCo";
import ResidentialPhysicalAddressFoCo from "../../AddressParticularsComponents/ResidentialAddressComponents/ResidentialPhysicalAddressFoCo";
import PostalCodeForm from "../../PostalComponents/PostalCodeForm";
import PostalAddressFormForeign from "../../PostalComponents/PostalAddressFormForeign";
import PostalAddressFormLocal from "../../PostalComponents/PostalAddressFormLocal";

const ResidentialDetails = ({
  designation,
  idType,
  disabled,
  errors,
  touched,
  isNonResident,
}) => {
  return (
    <>
      {(designation === "Director Shareholder" ||
        designation === "Shareholder") &&
        (idType === "Kenyan Citizen" || idType === "Minor") && (
          <IsNonResidentSelection
            disabled={disabled}
            errors={errors}
            touched={touched}
          />
        )}
      <div>
        {(((idType === "Kenyan Citizen" || idType === "Minor") &&
          isNonResident === "No") ||
          idType === "Foreign Resident") && (
          <>
            <div className="px-4 mt-4 space-y-4 bg-white rounded-sm shadow-sm sm:rounded md:rounded-md sm:p-6">
              <Field
                name="postalAddress"
                component={PostalAddressFormLocal}
                idType={idType}
                disabled={disabled}
              />
              <Field
                name="postalAddress"
                component={PostalCodeForm}
                disabled={disabled}
              />
            </div>
            <Field
              name="residentialAddressDetails"
              component={ResidentialAddressDetailsFormKeCiFoRe}
              colWidth={4}
              disabled={disabled}
            />
          </>
        )}
        {(idType === "Foreigner" ||
          ((idType === "Kenyan Citizen" || idType === "Minor") &&
            isNonResident === "Yes")) && (
          <>
            <div className="px-4 mt-4 space-y-4 bg-white rounded-sm shadow-sm sm:rounded md:rounded-md sm:p-6">
              <Field
                name="postalAddress"
                component={PostalAddressFormForeign}
                idType={idType}
                disabled={disabled}
              />
            </div>
            <Field
              name="residentialAddressDetails"
              component={ResidentialAddressDetailsFormFoMi}
              disabled={disabled}
            />
          </>
        )}
        {(idType === "Local Company" || idType === "Other e.g Parastatals") && (
          <>
            <div className="px-4 mt-4 space-y-4 bg-white rounded-sm shadow-sm sm:rounded md:rounded-md sm:p-6">
              <Field
                name="postalAddress"
                component={PostalAddressFormLocal}
                disabled={disabled}
              />
              <Field
                name="postalAddress"
                component={PostalCodeForm}
                disabled={disabled}
              />
            </div>
            <Field
              name="residentialAddressDetails"
              component={ResidentialPhysicalAddressLoCo}
              disabled={disabled}
            />
          </>
        )}
        {idType === "Foreign Company" && (
          <>
            <div className="px-4 mt-4 space-y-4 bg-white rounded-sm shadow-sm sm:rounded md:rounded-md sm:p-6">
              <Field
                name="postalAddress"
                component={PostalAddressFormForeign}
                disabled={disabled}
              />
            </div>
            <Field
              name="residentialAddressDetails"
              component={ResidentialPhysicalAddressFoCo}
              disabled={disabled}
            />
          </>
        )}
      </div>
    </>
  );
};

export default ResidentialDetails;
